import { Link } from 'react-router-dom';
import '../index.css';
import './CategoryCard.css';

const CategoryCard = (props) => {
    return ( 
        <div className="card">
            <Link to={`/info?category=${props.id}&keyword=`}>
                <img className="cat-img" src={props.image} alt=""/>
                <h3 data-testid="cat-name" className="h3 cat-txt">{props.title}</h3>
            </Link>
        </div>
     );
}
 
export default CategoryCard;